class WomenliArticleCarousel {
  /** @type {HTMLElement} */
  #root;

  /** @type {HTMLElement | null} */
  #track;

  /**
   * @param {HTMLElement} root
   */
  constructor(root) {
    this.#root = root;
    this.#track = root.querySelector('[data-carousel-track]');
    this.#bind();
  }

  #bind() {
    const prev = this.#root.querySelector('[data-carousel-prev]');
    const next = this.#root.querySelector('[data-carousel-next]');

    prev?.addEventListener('click', () => this.#scrollBy(-1));
    next?.addEventListener('click', () => this.#scrollBy(1));
  }

  /**
   * @param {number} direction
   */
  #scrollBy(direction) {
    if (!this.#track) return;

    const card = this.#track.querySelector('.womenli-article__product');
    const gap = parseFloat(getComputedStyle(this.#track).columnGap || '0') || 16;
    const amount = card ? card.getBoundingClientRect().width + gap : this.#track.clientWidth * 0.8;

    this.#track.scrollBy({
      left: direction * amount,
      behavior: 'smooth',
    });
  }
}

document.querySelectorAll('[data-womenli-article-carousel]').forEach((root) => {
  if (root instanceof HTMLElement) {
    new WomenliArticleCarousel(root);
  }
});
